import { IQueryContext } from 'framework/context/IQueryContext';
import { IQueryResult, IReservationDto, IReservationsQueryParams } from 'gen/ApiClient';
import React from 'react';

export const ReservationsQueryContext = React.createContext<IQueryContext<IQueryResult<IReservationDto>, IReservationsQueryParams>>(undefined as any);